import type { ExcalidrawAttributes } from "./attributes";

/* ------------------------------- EXCALIDRAW ------------------------------- */
export const EXCALIDRAW_EXTENSION_NAME = "excalidraw";

export const EXCALIDRAW_DEFAULT_ATTRIBUTES: ExcalidrawAttributes = {
  caption: "",
  data: null,
};
